// extracted by mini-css-extract-plugin
module.exports = {"quoteMark":"QuoteMark_quoteMark__1PlFP"};